export const downloadVectorizedImage = (imageBase64: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = imageBase64;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};